import { APIS } from '../../../utils/apiConfig';
import { createRequestUtility } from '../../../utils/httpUtils';
import { HttpService } from '../../HttpService/HttpService';

export class AdminDashboardService {
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  async getAllOrgDetails(): Promise<any> {
    return this.makeRequest('get', APIS.GET_ALL_SUPER_ADMIN_ORGANISATION(), {});
  }

  async getAnalytics(): Promise<any> {
    return this.makeRequest('get', APIS.GET_ADMIN_ANALYSIS_DETAILS(), {});
  }

  async getRecentActivities(): Promise<any> {
    return this.makeRequest('get', APIS.GET_ADMIN_RECENT_ACTIVITIES(), {});
  }

  async getAllOrgList(): Promise<any> {
    return this.makeRequest('get', APIS.GET_ALL_ORG_COST());
  }

  async updateUserDetails(params: any): Promise<any> {
    return this.makeRequest('patch', APIS.UPDATE_USERS_DETAILS(), params);
  }

  async deleteUserDetails(params: any): Promise<any> {
    return this.makeRequest('patch', APIS.DELETE_USERS_DETAILS(), params);
  }
}
